import Immutable from 'immutable';

export const State = Immutable.fromJS({
	orderList: [],
	searchText: '',
	statusFilter: '全部狀態',
	dateFilter: '0',
  selectedOrderId: '0',
});
